import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { RC_STATUS, SERVICE } from '../../config/devices';
import { selectors } from '../../modules/devices';
import { connectToRCWebsocket, rcHideModal } from '../../modules/devices/actions';
import { isActiveService } from '../../modules/devices/helpers/helpers';
import Loader from '../Loader';
import Modal from '../Modal';
import messages from './messages';

const isConnected = (device) =>
  isActiveService(device, SERVICE.REMOTE_CONFIGURATION) &&
  device?.services?.[SERVICE.REMOTE_CONFIGURATION]?.status === RC_STATUS.CONNECTED &&
  device?.services?.[SERVICE.REMOTE_CONFIGURATION]?.url;

const RCModal = () => {
  const dispatch = useDispatch();
  const show = useSelector(selectors.isRCModalOpen);
  const device = useSelector(selectors.getDeviceRCModal);
  useEffect(() => {
    if (show && device.id) {
      if (isConnected(device)) {
        window.open(device.services[SERVICE.REMOTE_CONFIGURATION].url, '_blank');
        dispatch(rcHideModal());
      } else {
        dispatch(connectToRCWebsocket(device.id));
        setTimeout(() => dispatch(rcHideModal()), 30 * 1000);
      }
    }
  }, [show, device]);

  return (
    <Modal
      canClose={false}
      maxWidth="xs"
      name="rc-modal"
      onClose={() => dispatch(rcHideModal())}
      open={show}
      title={<FormattedMessage {...messages.rcModalTitle} />}
    >
      <Box alignItems="center" display="flex" flexDirection="column" justifyContent="center" sx={{ minHeight: 200 }}>
        <Typography component="p" sx={{ mb: 3 }}>
          <FormattedMessage {...messages.rcModalWaitForConnection} />
        </Typography>
        <Loader alignItems="center" size={80} />
      </Box>
    </Modal>
  );
};

export default RCModal;
